import { ActivatedRoute } from '@angular/router';
import { myDigitalHomeBusinessRoute } from '../member-profile/my-digital-home-nav.util';

export function petStoreCodeFromRoute(route: ActivatedRoute): string {
  let r: ActivatedRoute | null = route;
  while (r) {
    const code = (r.snapshot.paramMap.get('storeCode') || '').trim();
    if (code) return code;
    r = r.parent;
  }
  return '';
}

export function petBusinessBase(storeCode: string): string[] {
  const code = (storeCode || '').trim();
  return code ? ['/mybusiness-pet', code] : myDigitalHomeBusinessRoute();
}

export function petBusinessHomeRoute(storeCode: string): string[] {
  return petBusinessBase(storeCode);
}

export function petBusinessAccountRoute(storeCode: string): string[] {
  return [...petBusinessBase(storeCode), 'account'];
}

export function petBusinessProductsRoute(storeCode: string): string[] {
  return [...petBusinessBase(storeCode), 'products'];
}

export function petBusinessCustomersRoute(storeCode: string): string[] {
  return [...petBusinessBase(storeCode), 'customers'];
}

export function petPatientsRoute(storeCode: string): string[] {
  return [...petBusinessBase(storeCode), 'customers'];
}

export function petPatientRoute(
  storeCode: string,
  patientId: number | string
): string[] {
  return [...petBusinessBase(storeCode), 'patient', String(patientId)];
}

export function petAddCustomerRoute(storeCode: string): string[] {
  return [...petBusinessBase(storeCode), 'addcustomer'];
}

export function petAppointmentsRoute(storeCode: string): string[] {
  return [...petBusinessBase(storeCode), 'appointments'];
}

export function petBusinessInvoicesRoute(storeCode: string): string[] {
  const code = (storeCode || '').trim();
  return code ? [...petBusinessBase(code), 'vruksha', 'invoices'] : myDigitalHomeBusinessRoute();
}

export function petBusinessInvoiceCreateRoute(storeCode: string): string[] {
  const code = (storeCode || '').trim();
  return code
    ? [...petBusinessBase(code), 'vruksha', 'invoice', 'create']
    : myDigitalHomeBusinessRoute();
}

export function petBusinessEnquiriesRoute(storeCode: string): string[] {
  return [...petBusinessBase(storeCode), 'enquiries'];
}

export function petBusinessPublicOrdersRoute(storeCode: string): string[] {
  return [...petBusinessBase(storeCode), 'public-orders'];
}

export function petBusinessTeamRoute(storeCode: string): string[] {
  return [...petBusinessBase(storeCode), 'team'];
}

export function petBusinessAttendanceRoute(storeCode: string): string[] {
  return [...petBusinessBase(storeCode), 'attendance'];
}

export function petBusinessServicesRoute(storeCode: string): string[] {
  return [...petBusinessBase(storeCode), 'services'];
}

export function petBusinessReportsRoute(storeCode: string): string[] {
  return [...petBusinessBase(storeCode), 'reports'];
}

export function petBusinessInvoiceViewRoute(
  storeCode: string,
  billId: number | string
): string[] {
  const code = (storeCode || '').trim();
  return code
    ? [...petBusinessBase(code), 'vruksha', 'invoice', 'view', String(billId)]
    : myDigitalHomeBusinessRoute();
}

export function petBusinessInvoiceSlipRoute(
  storeCode: string,
  billId: number | string
): string[] {
  const code = (storeCode || '').trim();
  return code
    ? [...petBusinessBase(code), 'vruksha', 'invoice', 'slip', String(billId)]
    : myDigitalHomeBusinessRoute();
}

export function isPetBusinessShellUrl(url: string): boolean {
  return (url || '').split('?')[0].includes('/mybusiness-pet/');
}

export function petDashboardCommands(storeCode: string): string[] {
  return petBusinessBase(storeCode);
}
